import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { RuleTranslator } from '@cbridge-packages/rule';
import { OrderLifetimeRuleAction } from '../orderLifetimeRule.action';
import { OrderLifetimeRuleTranslator } from '../orderLifetimeRule.translator';

type IDependencies = IClientApiDependencySegment;

export const updateOrderLifetimeRuleEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(OrderLifetimeRuleAction.update.started),
  mergeMap((params) => {
    const rules = params.map(OrderLifetimeRuleTranslator.toApi);
    return dependencies.api.updateOrderLifetimeRules({ rules }).pipe(
      mergeMap((response) => {
        return [
          OrderLifetimeRuleAction.update.done({ params, result: (response.rules ?? []).map(RuleTranslator.fromApiValidation) }),
        ];
      }),
      catchApiError((error) => {
        return [
          OrderLifetimeRuleAction.update.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
